import React from 'react';
import Grid from '@material-ui/core/Grid';
import makeStyles from '@material-ui/styles/makeStyles';
import useTheme from '@material-ui/styles/useTheme';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Card from '@material-ui/core/Card';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from "@material-ui/core/Typography";
import { TbCash, TbReceipt, TbTrendingUp } from "react-icons/tb";
import {useGlobalState} from '../../../state';



const useStyles = makeStyles(theme => ({
    container: {
        marginTop: theme.spacing(2)
    },
    loaderCard: {
        padding: theme.spacing(2),
        textAlign: 'center'
    },
    card: {
        height: '100%',
        padding: theme.spacing(2),
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(1.5, 1)
        }
    },
    iconBg: {
        width: 44,
        height: 44,
        borderRadius: 8,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: theme.spacing(1.5),
        [theme.breakpoints.down('xs')]: {
            width: 32,
            height: 32,
            marginBottom: theme.spacing(1),
            '& svg': {
                width: 18,
                height: 18
            }
        }
    },
    title: {
        marginBottom: theme.spacing(0.5),
        [theme.breakpoints.down('xs')]: {
            fontSize: 11,
            lineHeight: 1.3
        }
    },
    value: {
        [theme.breakpoints.down('xs')]: {
            fontSize: 14,
            fontWeight: 700,
            lineHeight: 1.3,
            wordBreak: 'break-word'
        }
    }
}));



const SummaryCard = ({ classes, icon: Icon, color, bg, title, value }) => (
    <Grid item xs={4}>
        <Card className={classes.card}>
            <div className={classes.iconBg} style={{ background: bg }}>
                <Icon color={color} size={24} />
            </div>
            <Typography className={classes.title} color="textSecondary">
                {title}
            </Typography>
            <Typography className={classes.value} variant="h3" component="h2">
                {value}
            </Typography>
        </Card>
    </Grid>
);



const Summary = ({ netProfitLoading, netProfitData }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('xs'));
    const classes = useStyles();
    const [{user}] = useGlobalState();
    const amountObj = {
        style: "currency",
        currency: user.currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      }



    return <>
        {netProfitLoading ?
            <Card className={`${classes.container} ${classes.loaderCard}`}>
                <CircularProgress />
            </Card>
            :
            <Grid container spacing={isMobile ? 1 : 2} className={classes.container}>
                <SummaryCard classes={classes} icon={TbCash} color='#27ae60' bg='#e9f7ef'
                    title='Total Receipts'
                    value={netProfitData.totalIncome.toLocaleString(user.locales,amountObj)} />
                <SummaryCard classes={classes} icon={TbReceipt} color='#e74c3c' bg='#fdecea'
                    title='Total Expense'
                    value={netProfitData.totalExpense.toLocaleString(user.locales,amountObj)} />
                <SummaryCard classes={classes} icon={TbTrendingUp} color='#f39c12' bg='#fef5e7'
                    title='Surplus/Deficit'
                    value={netProfitData.netProfit.toLocaleString(user.locales,amountObj)} />
            </Grid>
        }
    </ >
};


export default Summary;
